import { render, staticRenderFns } from "./ObjectNewFamily.vue?vue&type=template&id=2f5723bf&"
import script from "./ObjectNewFamily.vue?vue&type=script&lang=js&"
export * from "./ObjectNewFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports